import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Ausentismos } from '../../../../models/ausentismos';
import { UnidadesTiempoService } from '../../../../services/unidades-tiempo.service';
import { ConfigDataService } from '../../../../services/config-data.service';
import { CodigosNominaService } from '../../../../services/codigosNomina.service';
import { ClaseAusentismoService } from '../../../../services/clase-ausentismo.service';
import { PersonalService } from '../../../../services/personal.service';
import {MyValidations} from '../../../../utils/my-validations';
import { formatDate } from '@angular/common';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-ausentismos-detalle',
  templateUrl: './ausentismos-detalle.component.html',
  styleUrls: ['./ausentismos-detalle.component.css']
})
export class AusentismosDetalleComponent implements OnInit, AfterViewInit {
  
  constructor(private fb: FormBuilder, 
              private unidadesTiempoService: UnidadesTiempoService,
              private configDataSrv: ConfigDataService,
              private ausentismoSrv: ClaseAusentismoService,
              private codigosNominaService: CodigosNominaService,
              private personalService: PersonalService,
              private momentService: MomentSetService) { }

  @Input() set ausentismo(ausentismoRecibida: Ausentismos)
  {
    this.ausentismoForm = ausentismoRecibida;
    this.setearForm(ausentismoRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() ausentismosInvalida: boolean;

  form: FormGroup;
  ausentismoForm: Ausentismos;
  actualizarFormatoInputNumerico = false;
  submitted: boolean;
  formHabilitado: boolean;
  claseAusentismoList: any;
  unidadesTiempoList: any;
  NominaList: any;
  MensajeRetro = "";  
  porHoras: boolean = false;
  labelCantidad: string = "Cantidad Días"

  ngOnInit(): void
  {
    this.configDataSrv.getDatosNominas()
      .subscribe(
        data => {
          this.unidadesTiempoList=data["UnidadesTiempo"];
        },
        error => {
          console.log(error);
        });
    
    this.ausentismoSrv.getAll().subscribe(codigos => { this.claseAusentismoList = codigos});
    
    this.codigosNominaService.getAll().subscribe(
      codigos => 
      { 
        codigos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        this.NominaList = codigos;
      });
    
    this.configurarValidadores();
    this.setearForm(this.ausentismoForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      horaDesde: [''],
      horaHasta: [''],
      claseAusentismo: ['', Validators.required],
      cantidad: ['', Validators.required],
      unidadTiempo: ['', Validators.required],
      codigoNomina: [''],
      consumoContingente: ['', Validators.required]
    });
  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(ausentismo: Ausentismos)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(ausentismo?.id);
      this.form.controls['desde'].setValue(new Date(ausentismo?.desde));
      this.form.controls['hasta'].setValue(new Date(ausentismo?.hasta));
      this.form.controls['horaDesde'].setValue(ausentismo?.horaDesde);
      this.form.controls['horaHasta'].setValue(ausentismo?.horaHasta);
      this.form.controls['personal'].setValue(ausentismo?.personal);
      this.form.controls['claseAusentismo'].setValue(ausentismo?.claseAusentismo);
      this.form.controls['cantidad'].setValue(ausentismo?.cantidad);
      this.form.controls['codigoNomina'].setValue(ausentismo?.codigoNomina);
      this.form.controls['consumoContingente'].setValue(ausentismo?.consumoContingente);
      this.form.controls['unidadTiempo'].setValue(ausentismo?.unidadTiempo);
      
      if (ausentismo.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
      this.chequeoRetro();
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
      this.form.controls['codigoNomina'].disable();
      this.form.controls['consumoContingente'].disable();
      this.form.controls['unidadTiempo'].disable();
      if (this.form.controls["id"].value != 0)
      {
        this.habilitarSegunUnidad(this.form.controls['unidadTiempo'].value);
      }
    }
  }

  habilitarSegunUnidad(clase)
  {
    this.labelCantidad = "Cantidad Días"
    this.form.controls['cantidad'].enable();
    this.porHoras = false;
    this.setValidatorRequired('horaDesde', null);
    this.setValidatorRequired('horaHasta', null);
    if (clase == 1 || clase == 2 || clase == 3)
    {
      this.form.controls['cantidad'].disable();
      if (clase == 3) 
      {
        this.labelCantidad = "Cantidad Horas"
        this.porHoras = true;
        this.setValidatorRequired('horaDesde', Validators.required);
        this.setValidatorRequired('horaHasta', Validators.required);
      }
    }
  }

  ngAfterViewInit()
  {
    if (this.form.controls['id'].value != "0")
    {
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  onChangeClaseAusentismo(event)
  {
    this.porHoras = false;
    this.form.controls['codigoNomina'].setValue(null);
    this.form.controls['unidadTiempo'].setValue(null);
    this.form.controls['cantidad'].setValue(0);
    if(event.value != null)
    {
      let index = this.claseAusentismoList.findIndex(x => x.id == event.value)
      if (index != -1)
      {
        this.form.controls['codigoNomina'].setValue(this.claseAusentismoList[index].codigoNomina);
        this.form.controls['unidadTiempo'].setValue(this.claseAusentismoList[index].unidadTiempo);
        this.habilitarSegunUnidad(this.claseAusentismoList[index].unidadTiempo);
        this.calculoCantidad();
      }
    }
    else
    {
      this.habilitarSegunUnidad(0);
    }
  }

  onChangeFechas()
  {
    this.calculoCantidad();
    this.chequeoRetro();
  }

  onChangeHoras()
  {
    this.calculoCantidad();
  }

  onChangeCantidad()
  {
    let cantidad = this.form.get("cantidad").value;
    let ausentismo = this.form.get("claseAusentismo").value;

    let index = this.claseAusentismoList.findIndex(x => x.id == ausentismo);
    this.form.controls['consumoContingente'].setValue(0);
    if (index != -1)
    {
      if (this.claseAusentismoList[index].claseContingente != null)
      {
        this.form.controls['consumoContingente'].setValue(cantidad);
      }
    }    
  }

  chequeoRetro()
  {
    this.MensajeRetro = "";
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    
    this.personalService.ChequeoRetroactividad(this.ausentismoForm.personal, 'Ausentismos', desde, hasta, true).subscribe(
      data =>
      {
        let resul = data;
        if (resul.haceRetro)
        {
          let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
          this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
        }
      }
    );
  }

  calculoCantidad()
  {
    let cant = 0;
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    let clase = this.form.get("unidadTiempo").value;
    if (clase == 1 || clase == 2 || clase == 3)
    {
      if (clase == 3)
      {
        let horaDesde = this.form.get("horaDesde").value;
        let horaHasta = this.form.get("horaHasta").value;   
        let tiempoD = horaDesde.substring(0,5) + ":00";
        let tiempoH = horaHasta.substring(0,5) + ":00";
        
        desde = desde + " " + tiempoD;
        hasta = hasta + " " + tiempoH;
      }

      this.unidadesTiempoService.calcularTiempoByUnidad(clase, desde, hasta, this.ausentismoForm.personal).subscribe(
        data =>
        {
          cant = data;
          this.form.controls['cantidad'].setValue(cant);
        }
      );
    } 
    
  }
  
}

